
const IconInfo = () => (
    <img width={20} src={require(`./info.png`).default} alt="imagen" />
)


const IconVisa = () => (
    <img className="ml-10" width='30%' src={require(`./visa.png`).default} alt="imagen" />
)

const IconDownload = () => (
    <img width={60} src={require(`./descargar.svg`).default} alt="imagen" />
)

const IconMail = () => (
    <img width={60} src={require(`./correo.svg`).default} alt="imagen" />
)

const IconWaitEvicertia  = () =>  ( 
    <img width={50} src={require(`./waitEvicertia.svg`).default} alt="imagen" />
)

const IconWait  = () =>  ( 
    <img width={60} src={require(`./waitEvicertia.svg`).default} alt="imagen" />
)

const IconError = () => (
    <img width={60} src={require(`./error.svg`).default} alt="imagen" />
)


const IconUserPhone = () => (
    <img width={60} src={require(`./userPhone.svg`).default} alt="imagen" />
)
const IconWsp = () => (
    <img width={60} src={require(`./wsp.svg`).default} alt="imagen" />
)


export {
    IconInfo,
    IconVisa,
    IconDownload,
    IconWaitEvicertia,
    IconMail,
    IconError,
    IconWait,
    IconUserPhone,
    IconWsp
}